import { axiosInstance } from '@/modules/shared/lib/axios'

type Props = {
  companyId: string
  groupId: number
}

export function getCompaniesInGroup({ companyId, groupId }: Props) {
  return axiosInstance.get<string[]>(
    `/config-api/${companyId}/configuration/admin/companies/companiesInGroup`,
    { params: { groupId } }
  )
}
